// extracted by mini-css-extract-plugin
export var container = "footer-module--container--3Rk7L";
export var footer = "footer-module--footer--3L5Rb";